const API_KEY = "mr14v2oijk1jv4n8u49ixkv6raofcd";

export default API_KEY
